import { dynamicContentFragment } from './dynamicContentFragment';
import { graphql } from './graphql';

export const SearchModalsContentQuery = graphql(
  `
    query SearchModalsContent {
      searchModalsContent {
        modals {
          propertyConfig {
            title
            subtitle
          }

          budget {
            title
            subtitle
            footers {
              offMarket {
                ...DynamicContent
              }
              allProperties {
                ...DynamicContent
              }
            }
          }

          commuteAndLocation {
            locationScreen {
              title
              subtitle
            }
            commuteScreen {
              title
              subtitle
            }
          }
        }

        filterOptions {
          propertyTypes {
            label
            value
          }

          propertyStatus {
            label {
              text
              variant
            }
            value
            callout {
              text
              variant
            }
          }

          minBedroomsV2 {
            label
            value
          }

          minBathrooms {
            label
            value
          }

          indoorFeatures {
            label
            value
          }

          outdoorFeatures {
            label
            value
          }

          ecoFriendlyFeatures {
            label
            value
          }

          minCarSpaces {
            label
            value
          }

          minPricesV2 {
            rentalPriceOptions {
              label
              value
            }
            nonRentalPriceOptions {
              label
              value
            }
          }
          maxPricesV2 {
            rentalPriceOptions {
              label
              value
            }
            nonRentalPriceOptions {
              label
              value
            }
          }
        }
      }
    }
  `,
  [dynamicContentFragment],
);
